import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiSupportConversationGet } from '@/entities/support-chat/modules/api/supportChat';

export const useSupportConversation = (userId: string) =>
  useFetch({
    api: () => apiSupportConversationGet(userId),
    keywords: queryKeys.supportChat.conversation(userId),
    enabled: Boolean(userId),
    staleTime: 0,
  });
